module.exports = __webpack_public_path__ + "media/images/IMG_0035-4-6f9e0d6179e587857a42ac8b7f33ff0e.jpg";